import { useState, useCallback } from 'react';
import { Moment } from 'moment';

import { RankingDatesRangePickerProps, RankingQueryType } from './RankingDatesRangePicker';

interface RankingDateRangePickerHooksOutput {
  props: RankingDatesRangePickerProps;

  from?: string;
  to?: string;
}

export default function useRankingDatesRangePicker(): RankingDateRangePickerHooksOutput {
  const [[from, to], setRange] = useState<[Moment | null, Moment | null]>([null, null]);

  const [queryType, setQueryType] = useState<RankingQueryType>('active');

  const onChangeRange = useCallback((from: Moment | null, to: Moment | null) => {
    setRange([from, to]);
  }, []);

  const onChangeQueryType = useCallback(
    (newQueryType: RankingQueryType) => {
      if (queryType === newQueryType) return;

      setQueryType(newQueryType);
      if (newQueryType === 'active') {
        onChangeRange(null, null);
      }
    },
    [onChangeRange, queryType]
  );

  return {
    props: {
      from,
      to,
      onChangeRange,

      queryType,
      onChangeQueryType,
    },
    from: from && to ? from.toISOString() : undefined,
    to: from && to ? to.toISOString() : undefined,
  };
}
